/**
 * Silent, fire-and-forget waitlist capture used by public flows
 * (onboarding + scanner). Never blocks the caller. Never throws.
 * Errors log to console only.
 */
import { config } from "@/shared/config";

export type WaitlistSource = "onboarding" | "scanner";

export interface WaitlistPayload {
  source: WaitlistSource;
  business_name?: string;
  industry?: string;
  website?: string;
  email?: string;
  goals?: string[];
  metadata?: Record<string, unknown>;
}

export function captureWaitlist(payload: WaitlistPayload): void {
  const url = `${config.backendUrl}${config.apiPrefix}/waitlist`;
  // Fire-and-forget; do not await, do not throw.
  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true, // survives page transitions
  }).catch((err) => {
    // eslint-disable-next-line no-console
    console.warn("[waitlist] silent capture failed", err);
  });
}
